import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Profile = Loadable({
  loader: () => import('./views/Profile'),
  loading: Loading,
});

const EmailTemplates = Loadable({
  loader: () => import('./views/EmailTemplates/EmailTemplates'),
  loading: Loading,
});

const EditEmailTemplate = Loadable({
  loader: () => import('./views/EmailTemplates/EditEmailTemplate'),
  loading: Loading,
});

const ViewEmailTemplate = Loadable({
  loader: () => import('./views/EmailTemplates/ViewEmailTemplate'),
  loading: Loading,
});
const Contents = Loadable({
  loader: () => import('./views/Contents/Contents'),
  loading: Loading,
});

const EditContent = Loadable({
  loader: () => import('./views/Contents/EditContent'),
  loading: Loading,
});

const Categories = Loadable({
  loader: () => import('./views/Categories/Categories'),
  loading: Loading,
});

const AddCategory = Loadable({
  loader: () => import('./views/Categories/AddCategory'),
  loading: Loading,
});

const EditCategory = Loadable({
  loader: () => import('./views/Categories/EditCategory'),
  loading: Loading,
});


const Occasions = Loadable({
  loader: () => import('./views/Occasions/Occasions'),
  loading: Loading,
});

const AddOccasion = Loadable({
  loader: () => import('./views/Occasions/AddOccasion'),
  loading: Loading,
});

const EditOccasion = Loadable({
  loader: () => import('./views/Occasions/EditOccasion'),
  loading: Loading,
});

const SubCategories = Loadable({
  loader: () => import('./views/SubCategories/SubCategories'),
  loading: Loading,
});

const AddSubCategory = Loadable({
  loader: () => import('./views/SubCategories/AddSubCategory'),
  loading: Loading,
});

const EditSubCategory = Loadable({
  loader: () => import('./views/SubCategories/EditSubCategory'),
  loading: Loading,
});

const DealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/DealerShelf'),
  loading: Loading,
});

const AddDealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/AddDealerShelf'),
  loading: Loading,
});

const EditDealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/EditDealerShelf'),
  loading: Loading,
});

const Banners = Loadable({
  loader: () => import('./views/Banners/Banners'),
  loading: Loading,
});

const AddBanner = Loadable({
  loader: () => import('./views/Banners/AddBanner'),
  loading: Loading,
});

const EditBanner = Loadable({
  loader: () => import('./views/Banners/EditBanner'),
  loading: Loading,
});

const InAppNotifiactions = Loadable({
  loader: () => import('./views/InAppNotifiaction/InAppNotifiactions'),
  loading: Loading,
});
const AddInAppNotifiactions = Loadable({
  loader: () => import('./views/InAppNotifiaction/AddInAppNotifiaction'),
  loading: Loading,
});
const EditInAppNotifiactions = Loadable({
  loader: () => import('./views/InAppNotifiaction/EditInAppNotifiaction'),
  loading: Loading,
});



const AllRedeemCodes = Loadable({
  loader: () => import('./views/AllRedeemCodes/AllRedeemCodes'),
  loading: Loading,
});

const ViewAllRedeemCodes = Loadable({
  loader: () => import('./views/AllRedeemCodes/View'),
  loading: Loading,
});

const QuizEarnRedeemCodes = Loadable({
  loader: () => import('./views/QuizEarnRedeemCodes/QuizEarnRedeemCodes'),
  loading: Loading,
});

const EditQuizEarnRedeemCodes = Loadable({
  loader: () => import('./views/QuizEarnRedeemCodes/Edit'),
  loading: Loading,
});

const ViewQuizEarnRedeemCodes = Loadable({
  loader: () => import('./views/QuizEarnRedeemCodes/View'),
  loading: Loading,
});

const AdminBills = Loadable({
  loader: () => import('./views/AdminBills/AdminBills'),
  loading: Loading,
});

const ViewAdminBills = Loadable({
  loader: () => import('./views/AdminBills/View'),
  loading: Loading,
});

const RedeemCodesWithValue = Loadable({
  loader: () => import('./views/RedeemCodesWithValue/RedeemCodesWithValue'),
  loading: Loading,
});

const EditRedeemCodesWithValue = Loadable({
  loader: () => import('./views/RedeemCodesWithValue/Edit'),
  loading: Loading,
});

const ViewRedeemCodesWithValue = Loadable({
  loader: () => import('./views/RedeemCodesWithValue/View'),
  loading: Loading,
});

const Refer = Loadable({
  loader: () => import('./views/Refer/Refer'),
  loading: Loading,
});

const EditRefer = Loadable({
  loader: () => import('./views/Refer/Edit'),
  loading: Loading,
});

const ViewRefer = Loadable({
  loader: () => import('./views/Refer/View'),
  loading: Loading,
});

const Coins = Loadable({
  loader: () => import('./views/Coins/Coins'),
  loading: Loading,
});

const ViewCoins = Loadable({
  loader: () => import('./views/Coins/View'),
  loading: Loading,
});

const ViewCoinsDetail = Loadable({
  loader: () => import('./views/Coins/ViewDetail'),
  loading: Loading,
});

const Earn_redeem_codes = Loadable({
  loader: () => import('./views/Earn_redeem_codes/Earn_redeem_codes'),
  loading: Loading,
});

const ViewEarnRedeemCodes = Loadable({
  loader: () => import('./views/Earn_redeem_codes/View'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const AddUser = Loadable({
  loader: () => import('./views/Users/AddUser'),
  loading: Loading,
});

const EditUser = Loadable({
  loader: () => import('./views/Users/EditUser'),
  loading: Loading,
});
const ViewUser = Loadable({
  loader: () => import('./views/Users/ViewUser'),
  loading: Loading,
});
const ViewUserDetail = Loadable({
  loader: () => import('./views/Users/ViewUserDetail'),
  loading: Loading,
});

const Services = Loadable({
  loader: () => import('./views/Services/Services'),
  loading: Loading,
});

const AddService = Loadable({
  loader: () => import('./views/Services/AddService'),
  loading: Loading,
});

const EditService = Loadable({
  loader: () => import('./views/Services/EditService'),
  loading: Loading,
});

const UserAddress = Loadable({
  loader: () => import('./views/Users/UserAddress'),
  loading: Loading,
});

const Stores = Loadable({
  loader: () => import('./views/Stores/Stores'),
  loading: Loading,
});

const AddStore = Loadable({
  loader: () => import('./views/Stores/AddStore'),
  loading: Loading,
});

const EditStore = Loadable({
  loader: () => import('./views/Stores/EditStore'),
  loading: Loading,
});
const ViewStore = Loadable({
  loader: () => import('./views/Stores/ViewStore'),
  loading: Loading,
});
const ChangePassword = Loadable({
  loader: () => import('./views/Stores/ChangePassword'),
  loading: Loading,
});

const SetTimeStors = Loadable({
  loader: () => import('./views/Stores/SetTimeStors'),
  loading: Loading,
});

const ProductInventory = Loadable({
  loader: () => import('./views/Stores/ProductInventory'),
  loading: Loading,
});

const Products = Loadable({
  loader: () => import('./views/Products/Products'),
  loading: Loading,
});

const AddProduct = Loadable({
  loader: () => import('./views/Products/AddProduct'),
  loading: Loading,
});

const EditProduct = Loadable({
  loader: () => import('./views/Products/EditProduct'),
  loading: Loading,
});

const Posts = Loadable({
  loader: () => import('./views/Posts/Posts'),
  loading: Loading,
});

const AddPost = Loadable({
  loader: () => import('./views/Posts/AddPost'),
  loading: Loading,
});

const EditPost = Loadable({
  loader: () => import('./views/Posts/EditPost'),
  loading: Loading,
});

const DiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/DiscountCode'),
  loading: Loading,
});

const AddDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/AddDiscountCode'),
  loading: Loading,
});

const ViewDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/ViewDiscountCode'),
  loading: Loading,
});

const Deliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/Deliveryboys'),
  loading: Loading,
});

const AddDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/AddDeliveryboys'),
  loading: Loading,
});
const EditDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/EditDeliveryboys'),
  loading: Loading,
});

const ViewDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/ViewDeliveryboys'),
  loading: Loading,
});


const EditDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/EditDiscountCode'),
  loading: Loading,
});
const AddProductImages = Loadable({
  loader: () => import('./views/Products/AddProductImages'),
  loading: Loading,
});

const Orders = Loadable({
  loader: () => import('./views/Orders/Orders'),
  loading: Loading,
});

const OrdersHistory = Loadable({
  loader: () => import('./views/Orders/OrdersHistory'),
  loading: Loading,
});

const UserOrdersHistory = Loadable({
  loader: () => import('./views/Orders/UserOrdersHistory'),
  loading: Loading,
});
const UserWalletHistory = Loadable({
  loader: () => import('./views/Users/UserWalletHistory'),
  loading: Loading,
});

const StoreOrdersHistory = Loadable({
  loader: () => import('./views/Orders/StoreOrdersHistory'),
  loading: Loading,
});

const DriverOrdersHistory = Loadable({
  loader: () => import('./views/Orders/DriverOrdersHistory'),
  loading: Loading,
});

const ViewOrder = Loadable({
  loader: () => import('./views/Orders/ViewOrder'),
  loading: Loading,
});

const ViewOrderHistory = Loadable({
  loader: () => import('./views/Orders/ViewOrderHistory'),
  loading: Loading,
});

const GameCoins = Loadable({
  loader: () => import('./views/GameCoins/GameCoins'),
  loading: Loading,
});
const GameScore = Loadable({
  loader: () => import('./views/GameScore/GameScore'),
  loading: Loading,
});
const Settings = Loadable({
  loader: () => import('./views/Settings/Settings'),
  loading: Loading,
});
const DeliveryPrice = Loadable({
  loader: () => import('./views/DeliveryPrice/DeliveryPrice'),
  loading: Loading,
});

const Notifications = Loadable({
  loader: () => import('./views/Notifications/Notifications'),
  loading: Loading,
});
const AddNotification = Loadable({
  loader: () => import('./views/Notifications/AddNotification'),
  loading: Loading,
});

const LeaderboardPrizes = Loadable({
  loader: () => import('./views/LeaderboardPrizes/LeaderboardPrizes'),
  loading: Loading,
});

const GameLeaderboardPrizes = Loadable({
  loader: () => import('./views/LeaderboardPrizes/GameLeaderboardPrizes'),
  loading: Loading,
});

const LeaderboardSettings = Loadable({
  loader: () => import('./views/LeaderboardSettings/LeaderboardSettings'),
  loading: Loading,
});

const GameLeaderboardSettings = Loadable({
  loader: () => import('./views/LeaderboardSettings/GameLeaderboardSettings'),
  loading: Loading,
});

const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/profile', name: 'Profile', component: Profile },

  //Content Page Routes
  { path: '/contents', exact: true, name: 'Contents', component: Contents },
  { path: '/contents/edit-content', exact: true, name: 'Edit Content', component: EditContent },

  //EmailTemplates Page Routes
  { path: '/email-templates', exact: true, name: 'Email Templates', component: EmailTemplates },
  { path: '/email-templates/edit-email-template', exact: true, name: 'Edit Email Template', component: EditEmailTemplate },
  { path: '/email-templates/view-email-template', exact: true, name: 'View Email Template', component: ViewEmailTemplate },

  //Category Page Routes 
  { path: '/items/categories', exact: true, name: 'Categories', component: Categories },
  { path: '/items/categories/add-category', exact: true, name: 'Add Category', component: AddCategory },
  { path: '/items/categories/edit-category', exact: true, name: 'Edit Category', component: EditCategory },

  //Category Page Routes 
  { path: '/items/occasions', exact: true, name: 'Occasions', component: Occasions },
  { path: '/items/occasions/add-occasion', exact: true, name: 'Add Occasion', component: AddOccasion },
  { path: '/items/occasions/edit-occasion', exact: true, name: 'Edit Occasion', component: EditOccasion },


  //Sub Category Page Routes 
  { path: '/items/sub-categories', exact: true, name: 'Sub Categories', component: SubCategories },
  { path: '/items/sub-categories/add-sub-category', exact: true, name: 'Add Sub Category', component: AddSubCategory },
  { path: '/items/sub-categories/edit-sub-category', exact: true, name: 'Edit Sub Category', component: EditSubCategory },

  //Dealer Shelf Page Routes 
  { path: '/dealer/shelf', exact: true, name: 'Dealer Shelf', component: DealerShelf },
  { path: '/dealer/shelf/add-dealer-shelf', exact: true, name: 'Add Dealer Shelf', component: AddDealerShelf },
  { path: '/dealer/shelf/edit-dealer-shelf', exact: true, name: 'Edit Dealer Shelf', component: EditDealerShelf },


  //Banners Page Routes 
  { path: '/banners', exact: true, name: 'Banners', component: Banners },
  { path: '/banners/add-banner', exact: true, name: 'Add Banner', component: AddBanner },
  { path: '/banners/edit-banner', exact: true, name: 'Edit Banner', component: EditBanner },
  //InAppNotifiactions Page Routes 
  { path: '/in-app-notification', exact: true, name: 'InAppNotifiactions', component: InAppNotifiactions },
  { path: '/in-app-notification/add', exact: true, name: 'Add InAppNotifiactions', component: AddInAppNotifiactions },
  { path: '/in-app-notification/edit', exact: true, name: 'Edit InAppNotifiactions', component: EditInAppNotifiactions },

  // Users Page Routes
  { path: '/users', exact: true, name: 'Users', component: Users },
  { path: '/users/add-user', exact: true, name: 'Add User', component: AddUser },
  { path: '/users/edit-user', exact: true, name: 'Edit User', component: EditUser },
  { path: '/users/view-user', exact: true, name: 'View User', component: ViewUser },
  { path: '/users/view/:id', exact: true, name: 'View User', component: ViewUserDetail },
  { path: '/users/user-addresses', exact: true, name: 'View User Addresses', component: UserAddress },

  // Earn_redeem_codes Page Routes
  { path: '/earn_redeem_codes', exact: true, name: 'Earn redeem codes', component: Earn_redeem_codes },
  { path: '/earn_redeem_codes/view', exact: true, name: 'View', component: ViewEarnRedeemCodes },

  // Coins Page Routes
  { path: '/coins', exact: true, name: 'Coins', component: Coins },
  { path: '/coins/view', exact: true, name: 'View', component: ViewCoins },
  { path: '/coins/view/:id', exact: true, name: 'View', component: ViewCoinsDetail },

  // Refer Page Routes
  { path: '/refer', exact: true, name: 'Refer', component: Refer },
  { path: '/refer/edit', exact: true, name: 'Edit', component: EditRefer },
  { path: '/refer/view', exact: true, name: 'View', component: ViewRefer },

  // RedeemCodesWithValue Page Routes
  { path: '/redeem_codes_with_value', exact: true, name: 'Redeem Codes With Value', component: RedeemCodesWithValue },
  { path: '/redeem_codes_with_value/edit', exact: true, name: 'Edit', component: EditRedeemCodesWithValue },
  { path: '/redeem_codes_with_value/view', exact: true, name: 'View', component: ViewRedeemCodesWithValue },

  // QuizEarnRedeemCodes Page Routes
  { path: '/quiz_earn_redeem_codes', exact: true, name: 'Quiz Earn Redeem Codes', component: QuizEarnRedeemCodes },
  { path: '/quiz_earn_redeem_codes/edit', exact: true, name: 'Edit', component: EditQuizEarnRedeemCodes },
  { path: '/quiz_earn_redeem_codes/view', exact: true, name: 'View', component: ViewQuizEarnRedeemCodes },

  // AdminBills Page Routes
  { path: '/admin_bills', exact: true, name: 'Admin Bills', component: AdminBills },
  { path: '/admin_bills/view', exact: true, name: 'View', component: ViewAdminBills },

  // AllRedeemCodes Page Routes
  { path: '/all_redeem_codes', exact: true, name: 'All Redeem Codes', component: AllRedeemCodes },
  { path: '/all_redeem_codes/view', exact: true, name: 'View', component: ViewAllRedeemCodes },

  // Service Page Routes
  { path: '/services', exact: true, name: 'Services', component: Services },
  { path: '/services/add-service', exact: true, name: 'Add Service', component: AddService },
  { path: '/services/edit-service', exact: true, name: 'Edit Service', component: EditService },

  // Stores Page Routes
  { path: '/stores', exact: true, name: 'Branchs', component: Stores },
  { path: '/stores/add-store', exact: true, name: 'Add Branch', component: AddStore },
  { path: '/stores/edit-store', exact: true, name: 'Edit Branch', component: EditStore },
  { path: '/stores/change-password', exact: true, name: 'Change Password', component: ChangePassword },
  { path: '/stores/view-store', exact: true, name: 'View Branch', component: ViewStore },

  // Products Page Routes
  { path: '/items/products', exact: true, name: 'Products', component: Products },
  { path: '/items/products/add-product', exact: true, name: 'Add Product', component: AddProduct },
  { path: '/items/products/edit-product', exact: true, name: 'Edit Product', component: EditProduct },

  // Post Page Routes
  { path: '/posts', exact: true, name: 'Posts', component: Posts },
  { path: '/posts/add-post', exact: true, name: 'Add Post', component: AddPost },
  { path: '/posts/edit-post', exact: true, name: 'Edit Post', component: EditPost },

  //Product Images Page Routes
  { path: '/items/products/add-product-images', exact: true, name: 'Add Product Images', component: AddProductImages },

  // Discount Code Page Routes
  { path: '/discount-code', exact: true, name: 'Coupon Code', component: DiscountCode },
  { path: '/discount-code/add-discount-code', exact: true, name: 'Add Coupon Code', component: AddDiscountCode },
  { path: '/discount-code/edit-discount-code', exact: true, name: 'Edit Coupon Code', component: EditDiscountCode },
  { path: '/discount-code/view-discount-code', exact: true, name: 'View Coupon Code', component: ViewDiscountCode },

  // Driver Page Routes
  { path: '/delivery-boys', exact: true, name: 'Delivery boys', component: Deliveryboys },
  { path: '/delivery-boys/add-delivery-boy', exact: true, name: 'Add Delivery boy', component: AddDeliveryboys },
  { path: '/delivery-boys/edit-delivery-boy', exact: true, name: 'Edit Delivery boy', component: EditDeliveryboys },
  { path: '/delivery-boys/view-delivery-boy', exact: true, name: 'View Delivery boy', component: ViewDeliveryboys },


  // Order Page Routes
  { path: '/orders/list', exact: true, name: 'Orders', component: Orders },
  { path: '/orders/history', exact: true, name: 'Order History', component: OrdersHistory },
  { path: '/users/user-order-history/:userId', exact: true, name: 'Order History', component: UserOrdersHistory },
  { path: '/users/user-wallet-history/:userId', exact: true, name: 'Wallet History', component: UserWalletHistory },

  { path: '/stores/store-order-history/:storeId', exact: true, name: 'Order History', component: StoreOrdersHistory },
  { path: '/delivery-boys/delivery-boys-order-history/:driverId', exact: true, name: 'Order History', component: DriverOrdersHistory },
  { path: '/orders/view', exact: true, name: 'View Order', component: ViewOrder },
  { path: '/orders/view-order', exact: true, name: 'View Order', component: ViewOrderHistory },

  // Game Coin Manager Page Routes
  { path: '/game_coins', exact: true, name: 'Game Coins', component: GameCoins },
  // { path: '/users/view-user', exact: true, name: 'View User', component: ViewUser },
  // { path: '/users/view/:id', exact: true, name: 'View User', component: ViewUserDetail },

  // Leaderboard Prize Routes
  { path: '/leaderboard/prizes', exact: true, name: 'Leaderboard Prizes', component: LeaderboardPrizes },
  { path: '/leaderboard/game-prizes', exact: true, name: 'Game Leaderboard Prizes', component: GameLeaderboardPrizes },

  // Leaderboard Settings Routes
  { path: '/leaderboard/settings', exact: true, name: 'Leaderboard Settings', component: LeaderboardSettings },
  { path: '/leaderboard/game-settings', exact: true, name: 'Game Leaderboard Settings', component: GameLeaderboardSettings },

  //Game Score Page Routes
  { path: '/game_score', name: 'GameScore', component: GameScore },

  //Settings Page Routes
  { path: '/settings', name: 'Settings', component: Settings },
  { path: '/delivery-price', name: 'Delivery Price Manager', component: DeliveryPrice },

  //Notification Request Page Routes
  { path: '/notifications', exact: true, name: 'Notifications Manager', component: Notifications },
  { path: '/add-notification', exact: true, name: 'Add Notification', component: AddNotification },
];

export default routes;
